import _ChevronRightIcon from "@adsk/alloy-react-icon/es/lib/ChevronRightIcon";
import _Icon from "@adsk/alloy-react-icon/es/lib/Icon";
import _CheckmarkIcon from "@adsk/alloy-react-icon/es/lib/CheckmarkIcon";
import _styled, { default as _styled2, default as _styled3 } from "styled-components";
const _excluded = ["children", "label", "rightSideLabel", "selected", "disabled", "renderIcon", "className", "showSelection", "nested", "highlighted", "onClick", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import { noop } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const highlightedStyle = `
color: ${theme.tokens.colors.text.inverse.value};
background: ${theme.tokens.colors.background.selected.value};
`;
const StyledButton = styledC.button.withConfig({
  displayName: "MenuItem__StyledButton",
  componentId: "sc-106h7o0-0"
})(["display:inline-flex;align-items:center;background:none;border:none;border-radius:2px;outline:none;text-decoration:none;position:relative;justify-content:start;width:100%;height:36px;margin:0px;&:focus-within{box-shadow:none;}&:hover{background:", ";}&:active{background:", ";}padding:", ";cursor:", ";color:", ";", ";", ""], props => props.$highlighted ? theme.tokens.colors.background.selected.value : theme.tokens.colors.background.neutral.hover.value, props => props.$highlighted ? theme.tokens.colors.background.selected.value : theme.tokens.colors.background.neutral.pressed.value, props => props.$hasChildren ? `0 40px 0 ${theme.spacing.M}px` : `0 ${theme.spacing.M}px`, props => props.disabled ? 'no-drop' : 'pointer', props => props.disabled ? theme.tokens.colors.text.inactive.value : theme.tokens.colors.text.primary.value, props => props.$showSelection && props.$selected || props.$highlighted ? theme.typography.bodyMediumBold : theme.typography.bodyMedium, props => props.$highlighted ? highlightedStyle : undefined);

/** A MenuItem component which wraps an HTML li containing other children */
var _StyledStyledButton = styledC(StyledButton).withConfig({
  displayName: "MenuItem___StyledStyledButton",
  componentId: "sc-106h7o0-1"
})(["", ""], p => p.$_css);
const MenuItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      label,
      rightSideLabel,
      selected = false,
      disabled = false,
      renderIcon,
      className,
      showSelection = true,
      nested = false,
      highlighted,
      onClick,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledStyledButton, _extends({
    ref: ref,
    as: nested ? 'div' : undefined,
    className: className,
    disabled: disabled,
    onClick: disabled ? noop : onClick,
    $showSelection: showSelection,
    $selected: selected,
    $hasChildren: !!children || !!rightSideLabel,
    $highlighted: highlighted
  }, props, {
    $_css: style
  }), showSelection && (selected ? /*#__PURE__*/React.createElement(_CheckmarkIcon, {
    style: {
      flex: '0 0 22',
      color: `${theme.tokens.colors.icon.selected.value}`,
      marginRight: theme.spacing.XS,
      flexShrink: 0
    }
  }) :
  /*#__PURE__*/
  /* placeholder for styling, no icon displayed */
  React.createElement(_Icon, {
    style: {
      flex: '0 0 22',
      marginRight: theme.spacing.XS,
      flexShrink: 0
    }
  })), renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon({
    style: {
      marginRight: theme.spacing.XS,
      flexShrink: 0
    }
  }), label && /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: [theme.typography.ellipsis, {
      whiteSpace: 'nowrap'
    }]
  }, label), children, rightSideLabel && /*#__PURE__*/React.createElement(_StyledSpan2, {
    $_css3: [theme.typography.bodySmall, {
      position: 'absolute',
      right: 10,
      color: theme.tokens.colors.text.secondary.value
    }]
  }, rightSideLabel), nested && /*#__PURE__*/React.createElement(_ChevronRightIcon, {
    style: {
      position: 'absolute',
      right: 10,
      color: `${highlighted ? theme.tokens.colors.icon.inverse.value : theme.tokens.colors.icon.secondary.value}`
    }
  }));
});
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = {
  /** The content to category */
  children: PropTypes.any,
  /* Styles applied to the root element */
  style: stylePropType,
  /* Class applied to the root element */
  className: PropTypes.string,
  /** Determines if the item is selected and show V next to it */
  selected: PropTypes.bool,
  /** Determines if the V icon will show */
  showSelection: PropTypes.bool,
  /** Determines if item should apply highlighted styles  */
  highlighted: PropTypes.bool,
  /** Determines if the > icon will show */
  nested: PropTypes.bool,
  /** Determines if the item is disabled */
  disabled: PropTypes.bool,
  /** The button text */
  label: PropTypes.any,
  /** A text on the right side */
  rightSideLabel: PropTypes.any,
  /* Icon type to display on left */
  renderIcon: PropTypes.func,
  /** Handle for item click event */
  onClick: PropTypes.func
};
export default MenuItem;
var _StyledSpan = styledC("span").withConfig({
  displayName: "MenuItem___StyledSpan",
  componentId: "sc-106h7o0-2"
})(["", ""], p => p.$_css2);
var _StyledSpan2 = styledC("span").withConfig({
  displayName: "MenuItem___StyledSpan2",
  componentId: "sc-106h7o0-3"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=MenuItem.js.map